export default __webpack_public_path__ + "static/media/banner-3.1dae7e32.jpg";